export enum ENUM__rembg_model {
  U2NET = 'u2net',
  U2NETP = 'u2netp',
  U2NET_HUMAN_SEG = 'u2net_human_seg',

  U2NET_CLOTH_SEG = 'u2net_cloth_seg', //provides 3x bigger height image
  //
  SILUETA = 'silueta',
  //
  ISNET_GENERAL_USE = 'isnet-general-use',
  ISNET_ANIME = 'isnet-anime',
  //
  SAM = 'sam',
  //
  BIREFNET_GENERAL = 'birefnet-general',
  BIREFNET_GENERAL_LITE = 'birefnet-general-lite',
  BIREFNET_PORTRAIT = 'birefnet-portrait',
  BIREFNET_DIS = 'birefnet-dis',
  BIREFNET_HRSOD = 'birefnet-hrsod',
  BIREFNET_COD = 'birefnet-cod',
  BIREFNET_MASSIVE = 'birefnet-massive',
  //
  BRIA_RMBG = 'bria-rmbg',
  BRIA_RMBG_2 = 'bria-rmbg-2.0',
}

export namespace ENUM_UTILS__rembg_model {}
